import { AFFILIATES_LOGOS } from 'src/comps/Affiliate/constants'

export function affiliateHasLogo(affiliateId) {
  return affiliateId && AFFILIATES_LOGOS.includes(affiliateId)
}
